module.exports = __webpack_public_path__ + "img/agetech_platform-logo-white.35aecb45.png";